<div>
  <h3 class="title" translate="Request.Document.Dialog.EditFilingData"></h3>

  <div class="pt-1 pe-4 pb-4 ps-4">
    <!-- WARN: the package cannot be filed until these carry a value, or the user accepts it as it stands -->
    @if (hasMissingFields) {
      <div class="alert alert-warning mb-3" role="alert">
        <div translate="Modals.EditFilingData.MissingDataWarning"></div>
        <ul class="mb-0 ps-4">
          @for (labelKey of missingFieldLabels; track labelKey) {
            <li>{{ labelKey | translate }}</li>
          }
        </ul>
      </div>
    }

    <form class="row needs-validation has-validation" [formGroup]="form">
      <!-- ACCEPT: file it as it is. Sits with the warning it answers, but inside the form so the control can
           reach the formGroup. The warning stays up either way: accepting acknowledges the gap, it does not
           close it, and the request simply stops being held back. -->
      @if (hasMissingFields) {
        <div class="mb-3 col-12 d-flex align-items-center">
          <input class="checkbox form-check-input defaultheight" type="checkbox"
            formControlName="isAccepted" id="isAccepted" [attr.data-testid]="'accept-incomplete-filing-data'">
          <label class="form-check-label opacity-100 ms-2" for="isAccepted"
            translate="Modals.EditFilingData.AcceptIncompleteData"></label>
        </div>
      }
      <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <label for="legalEntityName" class="form-label" translate="Modals.EditFilingData.LegalEntityName"></label>
        <input type="text" id="legalEntityName" class="form-control" [value]="xbrlFilingData.legalEntityName"
          formControlName="legalEntityName" placeholder="{{ 'Modals.EditFilingData.LegalEntityName' | translate }}"
          autocomplete="off" required>
          <app-formcontrol-error-messages [forControl]="legalEntityNameControl"></app-formcontrol-error-messages>
        </div>
        <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
          <label for="legalEntityLegalForm" class="form-label" translate="Modals.EditFilingData.LegalForm"></label>
          <input type="text" id="legalEntityLegalForm" class="form-control" [value]="xbrlFilingData.legalEntityLegalForm"
            formControlName="legalEntityLegalForm" placeholder="{{ 'Modals.EditFilingData.LegalForm' | translate }}"
            autocomplete="off" required>
            <app-formcontrol-error-messages [forControl]="legalEntityLegalFormControl"></app-formcontrol-error-messages>
          </div>
          <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <label for="legalEntityRegisteredOffice" class="form-label" translate="Modals.EditFilingData.RegisteredOfficePlace"></label>
            <input type="text" id="legalEntityRegisteredOffice" class="form-control" [value]="xbrlFilingData.legalEntityRegisteredOffice"
              formControlName="legalEntityRegisteredOffice" placeholder="{{ 'Modals.EditFilingData.RegisteredOfficePlace' | translate }}"
              autocomplete="off" required>
              <app-formcontrol-error-messages [forControl]="legalEntityRegisteredOfficeControl"></app-formcontrol-error-messages>
            </div>
            <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
              <label for="chamberOfCommerceRegistrationNumber" class="form-label" translate="Modals.EditFilingData.ChamberOfCommerceRegistrationNumber"></label>
              <input type="text" id="chamberOfCommerceRegistrationNumber" class="form-control" [value]="xbrlFilingData.chamberOfCommerceRegistrationNumber"
                formControlName="chamberOfCommerceRegistrationNumber" placeholder="{{ 'Modals.EditFilingData.ChamberOfCommerceRegistrationNumber' | translate }}"
                autocomplete="off" required>
                <app-formcontrol-error-messages [forControl]="chamberOfCommerceRegistrationNumberControl"></app-formcontrol-error-messages>
              </div>
              <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <label for="legalEntityRegisteredType" class="form-label" translate="Modals.EditFilingData.LegalEntityRegisteredType"></label>
                <div ngbDropdown class="dropdown" ngDefaultControl name="legalEntityRegisteredType" id="legalEntityRegisteredType">
                  <button class="btn language dropdown-toggle form-control text-truncate default" type="button"
                    id="dropdownMenu" ngbDropdownToggle>
                    {{ "RegistrationType." + xbrlFilingData.legalEntityRegisteredType | translate }}
                    <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownMenu" class="w-100">
                    @for (entityType of legalEntityRegisteredTypeEnum | keyvalue; track entityType) {
                      <button ngbDropdownItem (click)="setDropdownValue('legalEntityRegisteredType', entityType.value); markFormAsDirty()">
                        {{ "RegistrationType." + entityType.value | translate }}
                      </button>
                    }
                  </div>
                </div>
              </div>
              <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <label for="financialReportingPeriodEndDate" class="form-label" translate="Modals.EditFilingData.FinancialReportingPeriodEndDate"></label>
                <datetime-picker (changeDateEmit)="updateDate('financialReportingPeriodEndDate', $event)" [pickerType]="'calendar'" [useDefaultDeadlineSpecs]="false" [previousDeadlineDate]="financialReportingPeriodEndDateForPicker" [placeholder]="'Request.View.Summary.ChooseDate' | translate"></datetime-picker>
                <app-formcontrol-error-messages [forControl]="financialReportingPeriodEndDateControl"></app-formcontrol-error-messages>
              </div>
              <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <label for="financialReportingPeriod" class="form-label" translate="Modals.EditFilingData.FinancialReportingPeriod"></label>
                <input type="text" id="financialReportingPeriod" class="form-control" [value]="xbrlFilingData.financialReportingPeriod"
                  formControlName="financialReportingPeriod" placeholder="{{ 'Modals.EditFilingData.FinancialReportingPeriod' | translate }}"
                  autocomplete="off" required>
                  <app-formcontrol-error-messages [forControl]="financialReportingPeriodControl"></app-formcontrol-error-messages>
                </div>
                <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <label for="language" class="form-label" translate="Modals.EditFilingData.Language"></label>
                  <div ngbDropdown class="dropdown" ngDefaultControl name="language" id="language">
                    <button class="btn language dropdown-toggle form-control text-truncate default" type="button"
                      id="dropdownMenu" ngbDropdownToggle>
                      {{ "Modals.EditFilingData.Languages." + xbrlFilingData.language | translate }}
                      <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownMenu" class="w-100">
                      @for (filingLanguage of filingDataLanguageEnum | keyvalue; track filingLanguage) {
                        <button ngbDropdownItem (click)="setDropdownValue('language', filingLanguage.value); markFormAsDirty()">
                          {{ "Modals.EditFilingData.Languages." + filingLanguage.value | translate }}
                        </button>
                      }
                    </div>
                  </div>
                </div>
                <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <label for="financialStatementsConsolidated" class="form-label" translate="Modals.EditFilingData.FinancialStatementConsolidated"></label>
                  <div ngbDropdown class="dropdown" ngDefaultControl name="financialStatementsConsolidated" id="financialStatementsConsolidated">
                    <button class="btn language dropdown-toggle form-control text-truncate default" type="button"
                      id="dropdownMenu" ngbDropdownToggle>
                      {{ convertBooleanToString(xbrlFilingData.financialStatementsConsolidated) }}
                      <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownMenu" class="w-100">
                      <button ngbDropdownItem value=true (click)="setDropdownValue('financialStatementsConsolidated', true); markFormAsDirty()"
                      translate="Yes"></button>
                      <button ngbDropdownItem value=false (click)="setDropdownValue('financialStatementsConsolidated', false); markFormAsDirty()"
                      translate="No"></button>
                    </div>
                  </div>
                </div>
                <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <label for="auditorsReportFinancialStatementsPresent" class="form-label" translate="Modals.EditFilingData.AuditorsReportPresent"></label>
                  <div ngbDropdown class="dropdown" ngDefaultControl name="auditorsReportFinancialStatementsPresent" id="auditorsReportFinancialStatementsPresent">
                    <button class="btn language dropdown-toggle form-control text-truncate default" type="button"
                      id="dropdownMenu" ngbDropdownToggle>
                      {{ convertBooleanToString(xbrlFilingData.auditorsReportFinancialStatementsPresent) }}
                      <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownMenu" class="w-100">
                      <button ngbDropdownItem value=true (click)="setDropdownValue('auditorsReportFinancialStatementsPresent', true); markFormAsDirty()"
                      translate="Yes"></button>
                      <button ngbDropdownItem value=false (click)="setDropdownValue('auditorsReportFinancialStatementsPresent', false); markFormAsDirty()"
                      translate="No"></button>
                    </div>
                  </div>
                </div>
                <!-- Adoption: read only once an actor answered the Adopt action, since that answer wins on every read -->
                <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <label for="documentAdoptionStatus" class="form-label" translate="Modals.EditFilingData.DocumentAdoptionStatus"></label>
                  <div ngbDropdown class="dropdown" ngDefaultControl name="documentAdoptionStatus" id="documentAdoptionStatus">
                    <button class="btn language dropdown-toggle form-control text-truncate default" type="button"
                      id="dropdownMenu" ngbDropdownToggle [disabled]="!adoptionIsEditable">
                      {{ convertBooleanToString(xbrlFilingData.documentAdoptionStatus) }}
                      <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownMenu" class="w-100">
                      <button ngbDropdownItem value=true (click)="setDropdownValue('documentAdoptionStatus', true); markFormAsDirty()"
                      translate="Yes"></button>
                      <button ngbDropdownItem value=false (click)="setDropdownValue('documentAdoptionStatus', false); markFormAsDirty()"
                      translate="No"></button>
                    </div>
                  </div>
                  @if (!adoptionIsEditable) {
                    <small class="form-text" translate="Modals.EditFilingData.AdoptionSetByAction"></small>
                  }
                </div>
                <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <label for="documentAdoptionDate" class="form-label" translate="Modals.EditFilingData.DocumentAdoptionDate"></label>
                  <!-- Not adopted means no adoption date, so the date follows the answer above -->
                  @if (adoptionDateIsEditable) {
                    <datetime-picker (changeDateEmit)="updateDate('documentAdoptionDate', $event)" [pickerType]="'calendar'" [useDefaultDeadlineSpecs]="false" [previousDeadlineDate]="documentAdoptionDateForPicker" [placeholder]="'Request.View.Summary.ChooseDate' | translate"></datetime-picker>
                  } @else {
                    <input type="text" id="documentAdoptionDate" class="form-control" [value]="formatDate(xbrlFilingData.documentAdoptionDate)"
                      autocomplete="off" disabled>
                  }
                  </div>
                  <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <label for="has403Field" class="form-label" translate="Modals.EditFilingData.AnnualReportForeignGroupArticle403"></label>
                    <div ngbDropdown class="dropdown" ngDefaultControl name="has403Field" id="has403Field">
                      <button class="btn language dropdown-toggle form-control text-truncate default" type="button"
                        id="dropdownMenu" ngbDropdownToggle>
                        {{ convertBooleanToString(xbrlFilingData.has403Field) }}
                        <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                      </button>
                      <div ngbDropdownMenu aria-labelledby="dropdownMenu" class="w-100">
                        <button ngbDropdownItem value=true (click)="setDropdownValue('has403Field', true); markFormAsDirty()"
                        translate="Yes"></button>
                        <button ngbDropdownItem value=false (click)="setDropdownValue('has403Field', false); markFormAsDirty()"
                        translate="No"></button>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <label for="has408Field" class="form-label" translate="Modals.EditFilingData.AnnualReportForeignGroupArticle408"></label>
                    <div ngbDropdown class="dropdown" ngDefaultControl name="has408Field" id="has408Field">
                      <button class="btn language dropdown-toggle form-control text-truncate default" type="button"
                        id="dropdownMenu" ngbDropdownToggle>
                        {{ convertBooleanToString(xbrlFilingData.has408Field) }}
                        <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                      </button>
                      <div ngbDropdownMenu aria-labelledby="dropdownMenu" class="w-100">
                        <button ngbDropdownItem value=true (click)="setDropdownValue('has408Field', true); markFormAsDirty()"
                        translate="Yes"></button>
                        <button ngbDropdownItem value=false (click)="setDropdownValue('has408Field', false); markFormAsDirty()"
                        translate="No"></button>
                      </div>
                    </div>
                  </div>

                  <div class="mb-2 w-100">
                    <button type="button" class="btn btn-sm btn-outline-primary float-start" (click)="close()" translate="Button.Back"></button>
                    <button type="button" class="btn btn-sm btn-primary float-end" (click)="save()" [disabled]="!canSave" translate="Button.Save"></button>
                  </div>
                </form>
              </div>
            </div>
